module.exports = __webpack_public_path__ + "static/media/daily_calendar.dbe78dc5.svg";